module.exports = __webpack_public_path__ + "media/images/front/top/1-6df43f8c697e83c8926cf619e751ef80.jpg";